import { render, staticRenderFns } from "./SchoolCategoryReport.vue?vue&type=template&id=2069081f&scoped=true"
import script from "./SchoolCategoryReport.vue?vue&type=script&lang=js"
export * from "./SchoolCategoryReport.vue?vue&type=script&lang=js"
import style0 from "./SchoolCategoryReport.vue?vue&type=style&index=0&id=2069081f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2069081f",
  null
  
)

export default component.exports